import { CONFIG } from "@rentiohq/shared-frontend/dist/config/app.config";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import {
  join,
  startsWithOneOf,
} from "@rentiohq/shared-frontend/dist/utils/string.utils";
import { ibanMask, ibanPipe } from "@rentiohq/web-shared/dist/utils/iban.utils";
import {
  ERentioFormField,
  IFormikValues,
  // IFormikValues,
  IUiSchema,
} from "@rentiohq/web-shared-next/dist/utils/types/form";
import { sortBy } from "lodash";
import { EField, IExtraData } from "./schema.addBankAccount.types";

export const uiSchema = (extraData: IExtraData): IUiSchema => {
  return {
    stepTitle: getLocalizedText("task.information.section_header"),
    heading: getLocalizedText("task.information.section_header"),
    fields: [
      {
        fieldKey: EField.IBAN,
        uiComponent: ERentioFormField.MaskedInput,
        title: getLocalizedText("payment_detail.form.iban.label"),
        required: true,
        additionalValidation: {
          name: "validate_sepa_support",
          test: (value: any, formData: IFormikValues) =>
            !(
              extraData.validateSepaSupported &&
              !startsWithOneOf(
                formData[EField.IBAN],
                CONFIG.SUPPORTED_SEPA_COUNTRIES,
              )
            ),
          message: getLocalizedText(
            "payment_detail.form.iban.label.error.not_allowed_iban",
            {
              countries: join(
                sortBy(
                  CONFIG.SUPPORTED_SEPA_COUNTRIES.map(x =>
                    getLocalizedText(`system.country.${x}`.toLowerCase()),
                  ),
                ),
              ),
            },
          ),
        },
        componentProps: {
          autoFocus: true,
          iMaskProps: {
            mask: ibanMask,
            pipe: ibanPipe,
            lazy: false,
            unmask: true,
          },
        },
      },
      {
        fieldKey: EField.OwnerName,
        uiComponent: ERentioFormField.TextField,
        title: getLocalizedText("payment_detail.form.card_holder_name.label"),
        required: true,
      },
    ],
  };
};
